'use strict';

/*global parseFloatK2*/
/*global roundToDecimals*/
/*global weightNetto*/
/*global weightBrutto*/

function ProcessUtilities() {

}

ProcessUtilities.prototype = $.extend({}, {
  constructor: 'ProcessUtilities',

  updateProcessItemsInfo: function updateProcessItemsInfo($items) {
    var _this = this;

    var articles = {};

    $items.each(function () {
      var $item = $(this);
      var articleId = $item.find('[name$="[ArticleId]"]').val();

      if (!(articleId in articles)) {
        articles[articleId] = 0;
      }

      articles[articleId]++;
    });

    $items.each(function () {
      var $item = $(this);
      var articleId = $item.find('[name$="[ArticleId]"]').val();
      var isZeroLevel = $item.find('[name$="[IsZeroLevel]"]').val();

      var info = '';
      if (isZeroLevel) {
        info = '<span class="icon icon--dot bg-primary"></span>';
      } else if (articles[articleId] > 1) {
        info = '<span class="glyphicon glyphicon-plus text-success"></span>';
      }

      $item.find('.process-item__title--info').append(info);
    });

    return _this;
  },

  getItemWeight: function getItemWeight($item, weightType) {
    var amount = parseFloatK2($item.find('[name$="[Amount]"]').val());

    var unitWeight = 0;

    switch (weightType) {
      case weightNetto : {
        unitWeight = parseFloatK2($item.find('[name$="[UnitWeightNetto]"]').val());
      }

      break;
      case weightBrutto : {
        unitWeight = parseFloatK2($item.find('[name$="[UnitWeightBrutto]"]').val());
      }

      break;
    }

    var weight = roundToDecimals(amount * unitWeight, 1);

    if (isNaN(weight)) {
      return 0;
    }

    return weight.toFixed(1);
  }
});
